import { render } from "./coursePreview.vue?vue&type=template&id=a9e052f6"
import script from "./coursePreview.vue?vue&type=script&lang=js"
export * from "./coursePreview.vue?vue&type=script&lang=js"

import "./coursePreview.vue?vue&type=style&index=0&id=a9e052f6&lang=css"

import exportComponent from "C:\\Project\\VuePro\\classCloud\\kclass-index-mtzls\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__